import React from 'react'

const TestimonialCard = ({ name, quote, content, rating, imageUrl, isOffset }) => (
    <div className={` pt-8 ${isOffset ? "mt-6" : ""}`}>
        <div className='flex items-center justify-between'>
            <div className=" flex items-center">
                <img src={imageUrl || "/placeholder.svg"} alt={name} className="w-12 h-12 rounded-full mr-2" />
                <div>
                    <h3 className="font-semibold">{name}</h3>
                    <div className="flex items-center text-sm gap-2 ">
                        <p className='text-sm'>Verified customer</p>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>

                    </div>
                </div>
            </div>
            <div className="">
                {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 inline-block text-yellow-400 fill-current" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                ))}
            </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow mt-6">
            <blockquote>
                <p className="text-lg font-bold italic mb-2">"{quote}"</p>
                <p className="text-gray-600">{content}</p>
            </blockquote>
        </div>
    </div>
)

export default TestimonialCard
